import dayjs from 'dayjs';

const isSameDay = (date) => dayjs(date).isSame(dayjs(), 'day');

export default isSameDay;
